'use client';
import i18next from 'i18next';
import {
  initReactI18next,
  useTranslation as useTranslationOrg,
} from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getOptions } from './settings';
import { setCookie, getCookie, cookieLangName } from '@src/cookie';
import {defaultLang } from './constant'
i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend((language, namespace) =>
      import(`./locales/${language}/${namespace}.json`).then(
        module => module.default
      )
    )
  )
  .init({
    ...getOptions(defaultLang),
    lng: detectLanguageOnClientSide(), 
    detection: {
      order: ['querystring', 'cookie', 'htmlTag', 'navigator'],
      caches: ['cookie'],
    },
  });

function detectLanguageOnClientSide() {
  const langCookie = getCookie(cookieLangName);
  if (!langCookie) {
    setCookie(cookieLangName, defaultLang, { expires: 365 });
  }
  return langCookie; 
}
export function init() {
  detectLanguageOnClientSide();
}
export function getLang() {
  return getCookie(cookieLangName) || defaultLang;
}
export async function changeLanguage(lang) {
  const storedLang = getCookie(cookieLangName);  
 
  if (storedLang !== lang) {
    setCookie(cookieLangName, lang);
     if (typeof window !== 'undefined'){
     window.location.reload();
     }
    
  }
}


export const useTranslation = useTranslationOrg;
